(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/join-team/assets/javascripts/join-team.js') >= 0) return;  svs.modules.push('/components/marketplace/join-team/assets/javascripts/join-team.js');

'use strict';

const {
  useEffect,
  useRef
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  Redirect
} = ReactRouterDOM;
const {
  actions
} = svs.components.marketplaceData.joinTeam;
const {
  actions: dialogActions
} = svs.components.marketplaceData.dialogWrapper;
const JoinTeam = props => {
  var _svs;
  const {
    match
  } = props;
  const dispatch = useDispatch();
  const hasFetchedInvitation = useRef(false);
  const termsUrl = "/dokument/".concat((_svs = svs) === null || _svs === void 0 || (_svs = _svs.marketplace) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.marketplaceDocumentId) === null || _svs === void 0 ? void 0 : _svs.documentId);
  const {
    loading,
    redirect,
    teamName
  } = useSelector(state => state.JoinTeam);
  useEffect(() => {
    if (hasFetchedInvitation.current === false) {
      hasFetchedInvitation.current = true;
      dispatch(actions.fetchInvitation(match.params.invitationToken));
    }
  }, [dispatch, match]);
  useEffect(() => {
    if (!redirect && !loading) {
      const dialogInfo = {
        title: "Bekr\xE4fta att du vill g\xE5 med i laget ".concat(teamName),
        text: "Genom att g\xE5 med i ett lag godk\xE4nner du <a class=\"qa-join-team-terms-link\" href=\"".concat(termsUrl, "\" rel=\"noopener noreferrer\" target=\"_BLANK\">villkor f\xF6r Spela tillsammans</a>"),
        buttons: [{
          text: 'Avbryt',
          callback: () => dispatch(actions.cancelJoin())
        }, {
          text: 'OK',
          callback: () => dispatch(actions.acceptInvite(match.params.invitationToken))
        }]
      };
      dispatch(dialogActions.showDialog(dialogInfo));
    }
  }, [dispatch, loading, redirect, teamName, match.params.invitationToken, termsUrl]);
  if (redirect) {
    return React.createElement(Redirect, {
      to: redirect
    });
  }
  return null;
};
JoinTeam.defaultProps = {
  items: {
    loading: true
  }
};
setGlobal('svs.components.marketplace.joinTeam.JoinTeam', JoinTeam);

 })(window);